import FrameBorder from '@/component/FrameBorder';
import Tables from '@/component/Tables';
import { getPackageHistory } from '@/Redux/futures/account/actions';
import backgroundImg from '@assets/web-v3-images/FrameBorder.png';
import { Table, Text } from '@radix-ui/themes';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { NoData } from './NoData';
import { formatHistoryDate } from '../formatDate';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import PATH from '@/config/PATH';

export default function Purchases() {
	const { t } = useTranslation();
	const [page, setPage] = useState(1);
	const dispatch = useDispatch();
	const navigate = useNavigate()
	const [dataResApi, setdataResApi] = useState(null)

	const afterGetPackageHistory = (data, isLoading) => {
		if (data) {
			setdataResApi(data)
		}
	}

	const getCurrentPayload = (page) => {
		if (page === 1) {
			return 0;
		}
		return page;
	};

	const getPackageHistoryPage = () => {
		const body = {
			query: {
				pageSize: 17,
				current: getCurrentPayload(page),
			},
			callback: afterGetPackageHistory
		}
		dispatch(getPackageHistory(body))
	}

	useEffect(() => {
		getPackageHistoryPage()
	}, [page]);

	const columns = [
		{ key: "pack_id", title: t("history.package_name") },
		{ key: "purchase_time", title: t("history.purchase_time") },
		{ key: "expired_time", title: t("history.expire_time") },
		{ key: "max_turn", title: t("history.turns") },
	];

	if (dataResApi && dataResApi?.data?.length === 0) {
		return (
			<div className='pt-[25%] px-10'>
				<NoData
					title={t("history.no_turn_purchases_yet")}
					describe={t("history.purchase_turns_to_start_guessing")}
					textBtn={t("history.shop_now")}
					handleClick={() => navigate(PATH.PACKAGE)}
				/>
			</div>
		);
	}

	return (
		<div className='mt-3 min-h-0 flex flex-col'>
			<FrameBorder fill>
				<div
					className="w-full bg-cover bg-no-repeat min-h-0 flex flex-col"
					style={{
						backgroundImage: `url(${backgroundImg})`,
					}}
				>
					<div className='mx-[8px] sm:mx-[30px] py-4 min-h-0 flex flex-col'>
						<Tables
							fill
							stickyHeader
							current={page}
							onChange={(p) => setPage(p)}
							columns={columns}
							pagination={true}
							data={dataResApi?.data || []}
							totalPages={Math.ceil((dataResApi?.total || 0) / Number(dataResApi?.pageSize || 1))}
							renderRow={(item) => (
								<Table.Row key={item.key}>
									<Table.Cell>
										<Text weight="bold" className="font-medium text-[rgba(113,59,18,1)]">{item.pack_id}</Text>
									</Table.Cell>
									<Table.Cell>
										<Text className="font-medium text-[rgba(113,59,18,1)]">{formatHistoryDate(item.purchase_time)}</Text>
									</Table.Cell>
									<Table.Cell>
										<Text className="font-medium text-[rgba(113,59,18,1)]">{formatHistoryDate(item.expired_time)}</Text>
									</Table.Cell>
									<Table.Cell>
										<Text className="font-medium text-[rgba(113,59,18,1)]">{item.max_turn}</Text>
									</Table.Cell>
								</Table.Row>
							)}
						/>
					</div>
				</div>
			</FrameBorder>
		</div>
	);
}